// Mixin de exportação SpreadsheetML (Excel 2003 XML) para o FluxoCaixaTabela.
//
// Depende via `this` das seguintes propriedades do componente hospedeiro:
//   computed : cabecalho, alturaHeader, colsPorDia, tipos, totalColunas,
//              linhasMovimentacoesVisiveis
//   props    : previstoRealizado, saldoInicialData, saldoFinalData
//   methods  : getValorSaldo, getValorNo, totalGeralPorContaSaldo,
//              totalSaldoPorDia, totalGeralSecao, totalGeralNo, tiposPorDia,
//              contasAgrupadasPorTipo, totalSaldoPorGrupoDia, totalGeralPorGrupoSaldo

export default {
    methods: {

        // ─── ponto de entrada ────────────────────────────────────────────────
        exportarExcel: function () {
            this._exportarDownload(this._xmlGerar(), 'FluxoCaixaGerencial.xls');
        },

        // ─── montagem do documento ───────────────────────────────────────────
        _xmlGerar: function () {
            return (
                '<?xml version="1.0" encoding="UTF-8"?>\n' +
                '<?mso-application progid="Excel.Sheet"?>\n' +
                '<Workbook' +
                ' xmlns="urn:schemas-microsoft-com:office:spreadsheet"' +
                ' xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"' +
                ' xmlns:x="urn:schemas-microsoft-com:office:excel">\n' +
                this._xmlEstilos() +
                '<Worksheet ss:Name="Fluxo de Caixa"><Table>\n' +
                this._xmlColunas() +
                this._xmlLinhasCabecalho() +
                this._xmlLinhasSecaoSaldo('saldoInicial', 'Saldo Inicial', 'Total Saldo Inicial') +
                this._xmlLinhasMovimentacoes() +
                this._xmlLinhasSecaoSaldo('saldoFinal',   'Saldo Final',   'Total Saldo Final') +
                '</Table></Worksheet>\n</Workbook>'
            );
        },

        // ─── bloco <Styles> ──────────────────────────────────────────────────
        _xmlEstilos: function () {
            var brd = (
                '<Borders>' +
                '<Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#000000"/>' +
                '<Border ss:Position="Left"   ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#000000"/>' +
                '<Border ss:Position="Right"  ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#000000"/>' +
                '<Border ss:Position="Top"    ss:LineStyle="Continuous" ss:Weight="1" ss:Color="#000000"/>' +
                '</Borders>'
            );
            var f      = '<Font ss:FontName="Calibri" ss:Size="11"/>';
            var fBold  = '<Font ss:FontName="Calibri" ss:Size="11" ss:Bold="1"/>';
            var fBlue  = '<Font ss:FontName="Calibri" ss:Size="11" ss:Color="#1E6CC7"/>';
            var fRed   = '<Font ss:FontName="Calibri" ss:Size="11" ss:Color="#C8312B"/>';
            var fBBlue = '<Font ss:FontName="Calibri" ss:Size="11" ss:Bold="1" ss:Color="#1E6CC7"/>';
            var fBRed  = '<Font ss:FontName="Calibri" ss:Size="11" ss:Bold="1" ss:Color="#C8312B"/>';
            var bgH    = '<Interior ss:Color="#F5F8FA" ss:Pattern="Solid"/>';
            var bgSec  = '<Interior ss:Color="#D6E9F8" ss:Pattern="Solid"/>';
            var bgTot  = '<Interior ss:Color="#E8EEF5" ss:Pattern="Solid"/>';
            var nf     = '<NumberFormat ss:Format="#,##0.00"/>';

            var estilos = [
                // Cabeçalho das colunas
                '<Style ss:ID="sH"><Alignment ss:Horizontal="Center" ss:Vertical="Center" ss:WrapText="1"/>' + brd + fBold  + bgH   + '</Style>',
                // Título de seção (Saldo Inicial / Movimentações / Saldo Final)
                '<Style ss:ID="sSec"><Alignment ss:Horizontal="Left" ss:Vertical="Center"/>'                 + brd + fBBlue + bgSec + '</Style>',
                // Rótulo de linha
                '<Style ss:ID="sLbl"><Alignment ss:Horizontal="Left" ss:Vertical="Center"/>'                 + brd + f              + '</Style>',
                // Rótulo de total
                '<Style ss:ID="sTLbl"><Alignment ss:Horizontal="Left" ss:Vertical="Center"/>'                + brd + fBold  + bgTot + '</Style>',
                // Valor positivo / zero
                '<Style ss:ID="sBlue"><Alignment ss:Horizontal="Right" ss:Vertical="Center"/>'               + brd + fBlue          + nf + '</Style>',
                // Valor negativo
                '<Style ss:ID="sRed"><Alignment ss:Horizontal="Right" ss:Vertical="Center"/>'                + brd + fRed           + nf + '</Style>',
                // Total positivo / zero
                '<Style ss:ID="sTBlue"><Alignment ss:Horizontal="Right" ss:Vertical="Center"/>'              + brd + fBBlue + bgTot + nf + '</Style>',
                // Total negativo
                '<Style ss:ID="sTRed"><Alignment ss:Horizontal="Right" ss:Vertical="Center"/>'               + brd + fBRed  + bgTot + nf + '</Style>'
            ];

            return '<Styles>' + estilos.join('') + '</Styles>\n';
        },

        // ─── helpers de célula ───────────────────────────────────────────────

        // Escapa caracteres reservados de XML no valor textual.
        _xmlEsc: function (v) {
            return String(v == null ? '' : v)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        },

        // Célula de texto.
        // opts: { idx (ss:Index 1-based), mcol (ss:MergeAcross), mrow (ss:MergeDown) }
        _xmlCell: function (valor, styleId, opts) {
            opts = opts || {};
            var a = ' ss:StyleID="' + styleId + '"';
            if (opts.idx)  a += ' ss:Index="'       + opts.idx  + '"';
            if (opts.mcol) a += ' ss:MergeAcross="' + opts.mcol + '"';
            if (opts.mrow) a += ' ss:MergeDown="'   + opts.mrow + '"';
            return '<Cell' + a + '><Data ss:Type="String">' + this._xmlEsc(valor) + '</Data></Cell>';
        },

        // Célula numérica — valor bruto; o formato #,##0.00 do estilo garante 2 casas.
        _xmlCellNum: function (n, bold) {
            n = n == null ? 0 : n;
            var s = bold ? (n < 0 ? 'sTRed' : 'sTBlue') : (n < 0 ? 'sRed' : 'sBlue');
            return '<Cell ss:StyleID="' + s + '"><Data ss:Type="Number">' + n + '</Data></Cell>';
        },

        // ─── geração de linhas ───────────────────────────────────────────────

        _xmlColunas: function () {
            var out = '<Column ss:Width="250"/>';
            for (var i = 1; i < this.totalColunas; i++) {
                out += '<Column ss:AutoFitWidth="1"/>';
            }
            return out;
        },

        _xmlLinhasCabecalho: function () {
            var self = this;
            var cab  = this.cabecalho;
            var altH = this.alturaHeader;
            var out  = '';

            // Linha 1: Conta | anos | Total Geral
            var r1 = '<Row>';
            r1 += self._xmlCell('Conta', 'sH', { mrow: altH - 1 });
            cab.anos.forEach(function (a) {
                r1 += self._xmlCell(a.ano, 'sH', { mcol: a.colspan - 1 });
            });
            r1 += self._xmlCell('Total\nGeral', 'sH', { mrow: altH - 1 });
            out += r1 + '</Row>\n';

            // Linha 2: meses
            // ss:Index=2 no primeiro para pular col "Conta" coberta pelo MergeDown acima.
            var r2 = '<Row>';
            cab.meses.forEach(function (m, i) {
                r2 += self._xmlCell(m.nome, 'sH', { mcol: m.colspan - 1, idx: i === 0 ? 2 : null });
            });
            out += r2 + '</Row>\n';

            // Linha 3: dias — colspan varia por data (passado: 3 cols, futuro: 1 col)
            var r3 = '<Row>';
            cab.dias.forEach(function (d, i) {
                var cpd = self.tiposPorDia(d.dataKey).length;
                r3 += self._xmlCell(d.label, 'sH', { mcol: cpd > 1 ? cpd - 1 : null, idx: i === 0 ? 2 : null });
            });
            out += r3 + '</Row>\n';

            // Linha 4: tipos — só quando previstoRealizado está ativo
            if (this.previstoRealizado) {
                var r4 = '<Row>';
                var first = true;
                cab.dias.forEach(function (d) {
                    self.tiposPorDia(d.dataKey).forEach(function (t) {
                        r4 += self._xmlCell(t === 'Delta' ? 'Δ' : t, 'sH', { idx: first ? 2 : null });
                        first = false;
                    });
                });
                out += r4 + '</Row>\n';
            }

            return out;
        },

        _xmlLinhasSecaoSaldo: function (qual, tituloSecao, tituloTotal) {
            var self      = this;
            var saldoData = qual === 'saldoInicial' ? this.saldoInicialData : this.saldoFinalData;
            var out       = '<Row>' + self._xmlCell(tituloSecao, 'sSec', { mcol: self.totalColunas - 1 }) + '</Row>\n';

            if (!saldoData || !saldoData.contas) return out;

            var grupos = this.contasAgrupadasPorTipo(saldoData);
            grupos.forEach(function (grupo) {
                // Cabeçalho do grupo com totais
                var rg = '<Row>' + self._xmlCell(grupo.tipoConta, 'sTLbl');
                self.cabecalho.dias.forEach(function (dia) {
                    self.tiposPorDia(dia.dataKey).forEach(function (tipo) {
                        rg += self._xmlCellNum(
                            self.totalSaldoPorGrupoDia(saldoData, grupo.contas, dia.dataKey, tipo), true);
                    });
                });
                rg += self._xmlCellNum(self.totalGeralPorGrupoSaldo(saldoData, grupo.contas), true);
                out += rg + '</Row>\n';

                // Contas do grupo (indentadas com 2 espaços)
                grupo.contas.forEach(function (conta) {
                    var r = '<Row>' + self._xmlCell('  ' + conta.nome, 'sLbl');
                    self.cabecalho.dias.forEach(function (dia) {
                        self.tiposPorDia(dia.dataKey).forEach(function (tipo) {
                            r += self._xmlCellNum(
                                self.getValorSaldo(saldoData, conta.handle, dia.dataKey, tipo), false);
                        });
                    });
                    r += self._xmlCellNum(self.totalGeralPorContaSaldo(saldoData, conta.handle), false);
                    out += r + '</Row>\n';
                });
            });

            var rt = '<Row>' + self._xmlCell(tituloTotal, 'sTLbl');
            self.cabecalho.dias.forEach(function (dia) {
                self.tiposPorDia(dia.dataKey).forEach(function (tipo) {
                    rt += self._xmlCellNum(self.totalSaldoPorDia(saldoData, dia.dataKey, tipo), true);
                });
            });
            rt += self._xmlCellNum(self.totalGeralSecao(qual), true);
            out += rt + '</Row>\n';

            return out;
        },

        _xmlLinhasMovimentacoes: function () {
            var self = this;
            var out  = '<Row>' + self._xmlCell('Movimentações', 'sSec', { mcol: self.totalColunas - 1 }) + '</Row>\n';

            this.linhasMovimentacoesVisiveis.forEach(function (linha) {
                var pad = '';
                for (var i = 0; i < linha.nivel; i++) pad += '  ';
                var r = '<Row>' + self._xmlCell(pad + linha.label, 'sLbl');
                self.cabecalho.dias.forEach(function (dia) {
                    self.tiposPorDia(dia.dataKey).forEach(function (tipo) {
                        r += self._xmlCellNum(self.getValorNo(linha, dia.dataKey, tipo), false);
                    });
                });
                r += self._xmlCellNum(self.totalGeralNo(linha), false);
                out += r + '</Row>\n';
            });

            return out;
        },

        // ─── download ────────────────────────────────────────────────────────
        _exportarDownload: function (conteudo, nomeArquivo) {
            var blob = new Blob([conteudo], { type: 'application/xml;charset=utf-8' });
            var url  = URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href     = url;
            link.download = nomeArquivo;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }
};
